"use client";

// src/scroll-area.tsx
import { cn } from "@momo/utils";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { jsx, jsxs } from "react/jsx-runtime";
var ScrollArea = (props) => {
  const { className, children, ...rest } = props;
  return /* @__PURE__ */ jsxs(ScrollAreaPrimitive.Root, { className: cn("relative overflow-hidden", className), ...rest, children: [
    /* @__PURE__ */ jsx(ScrollAreaPrimitive.Viewport, { className: "size-full rounded-[inherit]", children }),
    /* @__PURE__ */ jsx(ScrollBar, {}),
    /* @__PURE__ */ jsx(ScrollAreaPrimitive.Corner, {})
  ] });
};
var ScrollBar = (props) => {
  const { className, orientation = "vertical", ...rest } = props;
  return /* @__PURE__ */ jsx(
    ScrollAreaPrimitive.ScrollAreaScrollbar,
    {
      orientation,
      className: cn(
        "flex touch-none select-none transition-colors",
        orientation === "vertical" && "h-full w-2 border-l border-l-transparent p-px",
        orientation === "horizontal" && "h-2 flex-col border-t border-t-transparent p-px",
        className
      ),
      ...rest,
      children: /* @__PURE__ */ jsx(ScrollAreaPrimitive.ScrollAreaThumb, { className: "bg-border/70 hover:bg-border/80 relative flex-1 rounded-full transition-colors" })
    }
  );
};

export {
  ScrollArea,
  ScrollBar
};
